module.exports = __webpack_public_path__ + "static/media/new-patients-welcome2.9e4839fb.png";